import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Checkbox } from "../../../form";
import { IconV2 } from "../../../icon_v2";
const VerticalNav = ({ sections, defaultExpanded = [], className = "", sectionClassName = "px-5", menuItemClassName = "px-2 py-1.5", variant = "default", onCheckChange, }) => {
    const [expandedMenus, setExpandedMenus] = useState(new Set(defaultExpanded));
    const toggleMenu = (label) => {
        setExpandedMenus((prev) => {
            const next = new Set(prev);
            if (next.has(label)) {
                next.delete(label);
            }
            else {
                next.add(label);
            }
            return next;
        });
    };
    const [checkedItems, setCheckedItems] = useState(new Set());
    const toggleCheck = (item) => {
        setCheckedItems((prev) => {
            const next = new Set(prev);
            if (next.has(item.label)) {
                next.delete(item.label);
            }
            else {
                next.add(item.label);
            }
            return next;
        });
        onCheckChange === null || onCheckChange === void 0 ? void 0 : onCheckChange(item, !checkedItems.has(item.label));
    };
    // Base classes
    // w-[280px]
    const containerClasses = ` ${className}`;
    const sectionClasses = `${sectionClassName} border-b border-gray-200 dark:border-gray-700 last:border-b-0 py-6`;
    const sectionTitleClasses = "text-sm font-medium text-gray-500 dark:text-gray-400 mb-2";
    const menuItemsContainerClasses = "space-y-1";
    // Button classes
    const buttonBaseClasses = `w-full flex items-center justify-between rounded-md text-sm ${menuItemClassName}`;
    const buttonStateClasses = "transition-colors duration-200 ease-in-out hover:bg-gray-100 dark:hover:bg-gray-800";
    const buttonActiveClasses = "bg-gray-100 dark:bg-gray-800";
    // Icon classes
    const iconWrapperClasses = "transition-transform duration-200 ease-in-out hover:scale-110";
    const iconContainerClasses = "flex items-center gap-2";
    const iconSpacerClasses = "w-4"; // Same width as icons for consistent spacing
    // Badge classes
    const badgeBaseClasses = "px-1.5 py-0.5 text-xs rounded transition-all duration-200 ease-in-out hover:scale-105";
    const badgeVariantClasses = {
        new: "bg-green-100 text-green-700 hover:bg-green-200 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-800",
        number: "bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-800",
    };
    // Submenu classes
    const submenuContainerClasses = "pl-8 mt-1 space-y-1 overflow-hidden transition-all duration-200 ease-in-out";
    const submenuStateClasses = {
        expanded: "max-h-48 opacity-100",
        collapsed: "max-h-0 opacity-0",
    };
    const submenuItemClasses = "w-full text-left px-2 py-1.5 text-sm rounded-md transition-colors duration-200 ease-in-out hover:bg-gray-100 dark:hover:bg-gray-800";
    const renderMenuItem = (item, depth = 0) => (_jsxs("div", { children: [_jsxs("button", { className: `${buttonBaseClasses} ${buttonStateClasses} ${expandedMenus.has(item.label) ? buttonActiveClasses : ""}`, onClick: () => {
                    if (variant === "checkbox") {
                        toggleCheck(item);
                    }
                    if (item.submenu) {
                        toggleMenu(item.label);
                    }
                }, children: [_jsxs("div", { className: iconContainerClasses, children: [variant === "checkbox" ? (_jsx(Checkbox, { id: "defaultCheckbox", value: `${item.label}`, label: `${item.label}`, hideLabel: true, checked: checkedItems.has(item.label), onChange: () => toggleCheck(item) })) : // <input
                                //   type="checkbox"
                                //   checked={checkedItems.has(item.label)}
                                //   onChange={() => toggleCheck(item)}
                                //   className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                //   onClick={(e) => e.stopPropagation()}
                                // />
                                item.icon !== undefined ? (_jsx("span", { className: iconWrapperClasses, children: item.icon })) : (_jsx("span", { className: iconSpacerClasses })), _jsx("span", { className: "dark:text-white", children: item.label })] }), _jsxs("div", { className: iconContainerClasses, children: [item.badge !== undefined && (_jsx("span", { className: `${badgeBaseClasses} ${item.badge === "new"
                                    ? badgeVariantClasses.new
                                    : badgeVariantClasses.number}`, children: item.badge === "new" ? "New" : item.badge })), item.submenu && (_jsx("span", { className: iconWrapperClasses, children: expandedMenus.has(item.label) ? (_jsx(IconV2, { type: "fa", icon: {
                                        icon: ["far", "chevron-up"],
                                        size: "sm",
                                        color: "gray",
                                    } })) : (_jsx(IconV2, { type: "fa", icon: {
                                        icon: ["far", "chevron-down"],
                                        size: "sm",
                                        color: "gray",
                                    } })) }))] })] }), item.submenu && (_jsx("div", { className: `${submenuContainerClasses} ${expandedMenus.has(item.label)
                    ? submenuStateClasses.expanded
                    : submenuStateClasses.collapsed}`, children: item.submenu.map((subItem, subIndex) => (_jsx("div", { children: renderMenuItem(subItem, depth + 1) }, subIndex))) }))] }));
    return (_jsx("div", { className: containerClasses, children: sections.map((section, sectionIndex) => (_jsxs("div", { className: sectionClasses, children: [_jsx("h2", { className: sectionTitleClasses, children: section.title }), _jsx("div", { className: menuItemsContainerClasses, children: section.items.map((item, itemIndex) => (_jsx("div", { children: renderMenuItem(item) }, itemIndex))) })] }, sectionIndex))) }));
};
export default VerticalNav;
